import { initialState } from "reducers/TemplateEditor/State";
import { TemplateEditor, TemplatesHistory } from "constants/Actions";
import _ from "lodash";
import {
  filterAdapters,
  updateAdapterDataTokens,
  generateRules,
} from "functions/TemplateEditor";

const { GET_TEMPLATE_DATA } = TemplatesHistory;

const {
  SELECT_TEMPLATE_SECTION,
  UPDATE_SECTION_RULE,
  DELETE_SECTION_RULE,

  GET_PARAMETERS,
  GET_PARAMETERS_SUCCESS,
  GET_PARAMETERS_FAIL,
  RESET_PARAMETERS_SUCCESS,

  GET_SECTIONS,
  GET_SECTIONS_SUCCESS,
  GET_SECTIONS_FAIL,
  SAVE_SECTIONS,

  SAVE_TEMPLATE_RULE,
  SAVE_TEMPLATE_RULE_SUCCESS,
  SAVE_TEMPLATE_RULE_FAIL,

  GET_TEMPLATE_RULES,
  GET_TEMPLATE_RULES_SUCCESS,
  GET_TEMPLATE_RULES_FAIL,
  RESET_TEMPLATE_RULES,

  MANAGE_EDITOR_DRAWER,

  GET_PREVIEW_DATA,
  GET_PREVIEW_DATA_SUCCESS,
  GET_PREVIEW_DATA_FAIL,
  RESET_PREVIEW_DATA,

  GET_REPEATING_ADAPTERS,
  GET_REPEATING_ADAPTERS_SUCCESS,
  GET_REPEATING_ADAPTERS_FAIL,

  GET_REPEATING_ADAPTER_TOKENS,
  GET_REPEATING_ADAPTER_TOKENS_SUCCESS,
  GET_REPEATING_ADAPTER_TOKENS_FAIL,

  SET_EDITOR_SETTINGS,
  REFORM_SECTION_RULES,

  UPDATE_SECTION_EDITOR,

  GET_TEMPLATE_PREVIEW,
  GET_TEMPLATE_PREVIEW_SUCCESS,
  GET_TEMPLATE_PREVIEW_FAIL,
  RESET_TEMPLATE_PREVIEW,
} = TemplateEditor;

export default (state = initialState, { payload, type }: any) => {
  switch (type) {
    case SELECT_TEMPLATE_SECTION:
      return Object.assign({}, state, {
        section: {
          ...payload.data,
        },
      });
    case REFORM_SECTION_RULES:
      return Object.assign({}, state, {
        section: {
          ...state.section,
          rules: [...payload.data],
        },
      });
    case UPDATE_SECTION_RULE:
      return Object.assign({}, state, {
        section: {
          ...state.section,
          htmlContent: payload.data.content,
          rules: payload.data.rules,
        },
      });
    case DELETE_SECTION_RULE:
      return Object.assign({}, state, {
        section: {
          ...state.section,
          htmlContent: payload.data.content,
          rules: payload.data.rules,
        },
      });
    case GET_PARAMETERS:
      return Object.assign({}, state, {
        parameters: {
          ...state.parameters,
          isLoading: true,
        },
      });
    case GET_PARAMETERS_SUCCESS:
      return Object.assign({}, state, {
        parameters: {
          ...state.parameters,
          standard:
            filterAdapters(payload.data).length > 0
              ? filterAdapters(payload.data)[0]
              : initialState.parameters.standard,
          repeating: filterAdapters(payload.data, true) ?? [],
          isLoading: false,
        },
      });
    case GET_PARAMETERS_FAIL:
      return Object.assign({}, state, {
        parameters: {
          ...state.parameters,
          isLoading: false,
        },
      });

    case GET_SECTIONS:
      return Object.assign({}, state, {
        sections: {
          data: payload?.data,
          isLoading: true,
        },
      });
    case GET_SECTIONS_SUCCESS:
      return Object.assign({}, state, {
        sections: {
          data: payload.data,
          isLoading: false,
        },
      });
    case GET_SECTIONS_FAIL:
      return Object.assign({}, state, {
        sections: {
          data: payload.data,
          isLoading: false,
        },
      });
    case SAVE_SECTIONS:
      return Object.assign({}, state, {
        sections: {
          data: payload.data,
          isLoading: false,
        },
      });
    case SAVE_TEMPLATE_RULE:
      return Object.assign({}, state, {
        templateRules: {
          ...state.templateRules,
          isSaving: true,
        },
      });
    case SAVE_TEMPLATE_RULE_SUCCESS:
      return Object.assign({}, state, {
        templateRules: {
          ...state.templateRules,
          isSaving: false,
        },
      });
    case SAVE_TEMPLATE_RULE_FAIL:
      return Object.assign({}, state, {
        templateRules: {
          ...state.templateRules,
          isSaving: false,
        },
      });

    case GET_TEMPLATE_RULES:
      return Object.assign({}, state, {
        templateRules: {
          ...initialState.templateRules,
          isLoading: true,
        },
      });
    case GET_TEMPLATE_RULES_SUCCESS:
      return Object.assign({}, state, {
        templateRules: {
          ...state.templateRules,
          data: {
            ...payload.data,
            ruleExpressions: Array.isArray(payload.data?.ruleExpressions)
              ? payload.data?.ruleExpressions
              : [],
            rules: generateRules(payload.data?.ruleExpressions, "template"),
          },
          isLoading: false,
        },
      });
    case GET_TEMPLATE_RULES_FAIL:
      return Object.assign({}, state, {
        templateRules: {
          ...state.templateRules,
          isLoading: false,
        },
      });
    case RESET_TEMPLATE_RULES:
      return Object.assign({}, state, {
        templateRules: {
          ...initialState.templateRules,
          isLoading: false,
        },
      });
    case MANAGE_EDITOR_DRAWER:
      return Object.assign({}, state, {
        drawerInfo: {
          ...state.drawerInfo,
          ...payload.data,
          visible: !state.drawerInfo.visible,
        },
      });
    case GET_PREVIEW_DATA:
      return Object.assign({}, state, {
        previewData: {
          data: [],
          isLoading: true,
        },
      });
    case GET_PREVIEW_DATA_SUCCESS:
      return Object.assign({}, state, {
        previewData: {
          data: payload.data,
          isLoading: false,
        },
      });
    case GET_PREVIEW_DATA_FAIL:
      return Object.assign({}, state, {
        previewData: {
          ...state.previewData,
          isLoading: false,
        },
      });
    case RESET_PREVIEW_DATA:
      return Object.assign({}, state, {
        previewData: {
          data: [],
          isLoading: false,
        },
      });
    case GET_REPEATING_ADAPTERS:
      return Object.assign({}, state, {
        repeatingAdapters: {
          data: [],
          isLoading: true,
        },
      });
    case GET_REPEATING_ADAPTERS_SUCCESS:
      return Object.assign({}, state, {
        repeatingAdapters: {
          data: payload.data,
          isLoading: false,
        },
      });
    case GET_REPEATING_ADAPTERS_FAIL:
      return Object.assign({}, state, {
        repeatingAdapters: {
          ...state.repeatingAdapters,
          isLoading: false,
        },
        parameters: {
          ...state.parameters,
          isLoading: false,
        },
      });
    case GET_REPEATING_ADAPTER_TOKENS_SUCCESS:
      return Object.assign({}, state, {
        repeatingAdapters: {
          data: updateAdapterDataTokens(
            state.repeatingAdapters.data,
            payload.data
          ),
          isLoading: false,
        },
      });
    case SET_EDITOR_SETTINGS:
      return Object.assign({}, state, {
        editorSettings: {
          ...state.editorSettings,
          ...payload.data,
        },
      });
    case GET_TEMPLATE_DATA:
      return Object.assign({}, state, {
        parameters: {
          ...initialState.parameters,
          isLoading: true,
        },
      });
    case RESET_PARAMETERS_SUCCESS:
      return Object.assign({}, state, {
        parameters: {
          ...initialState.parameters,
          isLoading: true,
        },
      });
    case GET_TEMPLATE_PREVIEW:
      return Object.assign({}, state, {
        templatePreview: {
          data: [],
          isLoading: true,
        },
      });
    case GET_TEMPLATE_PREVIEW_SUCCESS:
      return Object.assign({}, state, {
        templatePreview: {
          data: payload.data,
          isLoading: false,
        },
      });
    case GET_TEMPLATE_PREVIEW_FAIL:
      return Object.assign({}, state, {
        templatePreview: {
          data: payload.data,
          isLoading: false,
        },
      });
    case RESET_TEMPLATE_PREVIEW:
      return Object.assign({}, state, {
        templatePreview: {
          data: [],
          isLoading: false,
        },
      });
    default:
      return state;
  }
};
